module.exports = __webpack_public_path__ + "static/media/paintings.c474f48e.jpg";